import { Shield, Trash2 } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

export const DangerSettings = ({
  showConfirmCard,
  setShowConfirmCard,
  deleting,
  handleDeleteAccount,
  confirmText,
  setConfirmText,
}) => {
  return (
    <>
      {/* Danger Zone Panel */}
      <Card className="border-0 shadow-lg rounded-2xl border-red-200">
        <CardHeader className="bg-gradient-to-r from-red-500 to-red-600 text-white rounded-t-2xl">
          <CardTitle className="flex items-center text-lg">
            <Shield className="w-5 h-5 mr-3" />
            Danger Zone
          </CardTitle>
        </CardHeader>

        <CardContent className="!p-6">
          <div className="space-y-4">
            <div>
              <h3 className="font-medium text-slate-800 mb-2">
                Delete Account
              </h3>
              <p className="text-sm text-slate-600 mb-4">
                Permanently delete your account and all associated data. This
                action cannot be undone.
              </p>
              <Button
                variant="destructive"
                onClick={() => setShowConfirmCard(true)}
              >
                <Trash2 className="mr-2 h-4 w-4" />
                Delete Account
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Modal Overlay */}
      {showConfirmCard && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <Card className="w-full max-w-md p-6">
            <CardTitle className="text-xl font-semibold text-destructive mb-2">
              Confirm Account Deletion
            </CardTitle>
            <p className="text-sm text-muted-foreground mb-4">
              Please type{" "}
              <span className="font-bold text-destructive">"Confirm"</span>{" "}
              below to permanently delete your account.
            </p>
            <Input
              placeholder='Type "Confirm"'
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              className="mb-4"
            />

            <div className="flex justify-end gap-3">
              <Button
                variant="outline"
                onClick={() => {
                  setShowConfirmCard(false);
                  setConfirmText("");
                }}
              >
                Cancel
              </Button>
              <Button
                variant="destructive"
                onClick={handleDeleteAccount}
                disabled={deleting}
              >
                {deleting ? "Deleting..." : "Confirm Delete"}
              </Button>
            </div>
          </Card>
        </div>
      )}
    </>
  );
};
